module.exports = __webpack_public_path__ + "img/CY.0e76950b.svg";